import stone from "./textures/stone.webp"

export type StoneTone = "dark" | "header"

export type StoneTexture = {
  src: string
  // Intrinsic pixel size of the asset. Displayed at src / pixelRatio CSS px so a 2x export stays sharp on retina.
  width: number
  height: number
  pixelRatio: number
  opacityClass: string
  sizeClass: string
}

export type StoneToneSkin = {
  // Tailwind bg-* token for the fill layer (Figma: BG fill).
  fill: string
  texture: StoneTexture
}

// Figma "Header bg texture" sits on the fill at 30%. The asset is exported at full opacity
// (the 30% was baked into its alpha; unbaked here) so the tone owns the opacity.
const stoneTexture: StoneTexture = {
  src: stone.src,
  opacityClass: "opacity-30",
  sizeClass: "bg-auto",
  width: stone.width,
  height: stone.height,
  pixelRatio: 2,
}

export const stoneTones: Record<StoneTone, StoneToneSkin> = {
  // Figma BG fill reads as black-1000 in the export; black-800 sits at the same luminance as the
  // top of the stroke gradient and hides it.
  dark: {
    fill: "",
    texture: stoneTexture
  },
  header: {
    fill: "",
    texture: {
      ...stoneTexture,
      opacityClass: "",
      sizeClass: "bg-[length:100%_auto] bg-repeat-x "
    }
  }
}
